import { ForwardedRef, forwardRef } from 'react'

import { Input } from 'core-components/library/inputs'

import { IValidateInputProps } from './models/IValidateInputProps'
import { ValidateInputWrapper } from './ValidateInputWrapper'

export const ValidateInput = forwardRef(
  (props: IValidateInputProps, ref: ForwardedRef<HTMLInputElement>) => {
    return <ValidateInputWrapper {...props} InputComponent={Input} inputRef={ref} />
  }
)

ValidateInput.displayName = 'ValidateInput'
